// extracted by mini-css-extract-plugin
module.exports = {"AddFileButton":"styles_AddFileButton__8RHDQ"};